module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAaUlEQVR42u2TSw7AIAgFn57EG8rN8QbTTU2MaarWdtdZQUL4PEBqANCAPiZqkwhkwGtmBjQxDphOI61WBhLgU3Pf6bGtQdjpYHp1n44Qu4wZsFn/6pDCov9r8JYG5ekzSSoCrL7zIg7YAfHL4D1EYAGfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/calendar-icon.png
// module id = 564
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22